import { render, staticRenderFns } from "./AgreementList.vue?vue&type=template&id=085193da&scoped=true"
import script from "./AgreementList.vue?vue&type=script&lang=js"
export * from "./AgreementList.vue?vue&type=script&lang=js"
import style0 from "./AgreementList.vue?vue&type=style&index=0&id=085193da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085193da",
  null
  
)

export default component.exports